import AnnualSummaryError from './AnnualSummaryError';
class AnnualSummaryInvalidPropertyId extends AnnualSummaryError {
    propertyId;
    constructor(propertyId, options) {
        super('Crowdfunding property id is not in the correct format', options);
        this.propertyId = propertyId;
    }
}
export default AnnualSummaryInvalidPropertyId;
